module.exports = __webpack_public_path__ + "img/circle-error.5df38c07.svg";